<template>
	<div class="city" v-loading="loading">
		<!-- <div class="cityHead">
			<i @click="returnHome"></i>
			<span>城市选择</span>
		</div> -->

		<div class="searchCon">
			<!-- <span class="nowCity">{{nowCity}}</span> -->
			<input id="seachInput" type="text" class="seachInput" placeholder="搜索你想去的地方" v-model="keywords" autocomplete="off">
		</div>

		<div class="returnMyCity">
			<span @click="getLocation">回到当前定位</span>
		</div>

		<div v-if="historyList.length != 0" class="history">
			<div class="historyTit">历史搜索</div>
			<ul class="historyList">
				<li @click="toHome(item.areaName,item.LocationCity,item.locationLat,item.locationLon)" v-for="(item,index) in historyList" :key="index">{{item.LocationCity}}</li>
			</ul>

		</div>

		<!-- <div class="nowAddress">
			<div class="nowAddressTit">当前/已选站点</div>
			<div class="nowAddressList">
				<div class="eachAddress active">成都站</div>
				<div class="eachAddress">成都站</div>
			</div>
		</div>

		<div class="nowAddress">
			<div class="nowAddressTit">热门站点</div>
			<div class="nowAddressList">
				<div class="eachAddress active">成都站</div>
				<div class="eachAddress">成都站</div>
				<div class="eachAddress active">成都站</div>
				<div class="eachAddress">成都站</div>
			</div>
		</div>

		<div class="cityList">
			<div class="eachWord">
				<div class="eachWordTit">A</div>
				<div class="eachWordList">
					<div>安亭站</div>
					<div>安亭站</div>
					<div>安亭站</div>
					<div>安亭站</div>
				</div>
			</div>
			<div class="eachWord">
				<div class="eachWordTit">B</div>
				<div class="eachWordList">
					<div>安亭站</div>
					<div>安亭站</div>
					<div>安亭站</div>
					<div>安亭站</div>
				</div>
			</div>
		</div>
		
		<div id="container"></div> -->

		<div v-show="!loading">
			<FootTab></FootTab>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import FootTab from "@/components/FootTab.vue";

	export default {
		name: "home",
		components: {
			FootTab
		},
		data() {
			return {
				"keywords": "",
				"isChangeAddress": false,
				"nowCity": "",
				"historyList": [],
				"loading": false
			}
		},
		activated() {

		},
		created() {
			this.nowCity = localStorage.getItem("LocationCity");

			if (localStorage.getItem("historyList")) {
				this.historyList = eval('(' + localStorage.getItem("historyList") + ')');
			}

		},
		mounted() {
			var that = this;
			that.inputTip();

		},
		watch: {
			keywords: function(val) {
				var that = this;
				console.log(val);
				var autoOptions = {
					city: '全国'
				}
				var autoComplete = new AMap.Autocomplete(autoOptions);
				autoComplete.search(val, function(status, result) {
					// 搜索成功时，result即是对应的匹配数据
					console.log(result);

					if (result.info == "OK" && that.isChangeAddress) {
						if (result.tips[0].location) {
							if (result.tips[0].district.indexOf("市") > -1) {
								localStorage.setItem("areaName", result.tips[0].district.split("市")[0] + "市");
							} else{
								localStorage.setItem("areaName", "");
							}
							
							localStorage.setItem("LocationCity", result.tips[0].name);
							localStorage.setItem("locationLat", result.tips[0].location.lat);
							localStorage.setItem("locationLon", result.tips[0].location.lng);
						} else {
							if (result.tips[1].district.indexOf("市") > -1) {
								localStorage.setItem("areaName", result.tips[1].district.split("市")[0] + "市");
							} else{
								localStorage.setItem("areaName", "");
							}
							
							localStorage.setItem("areaName", result.tips[1].district);
							localStorage.setItem("LocationCity", result.tips[1].name);
							localStorage.setItem("locationLat", result.tips[1].location.lat);
							localStorage.setItem("locationLon", result.tips[1].location.lng);
						}

						const selectCity = {
							"areaName": localStorage.getItem("areaName"),
							"LocationCity": localStorage.getItem("LocationCity"),
							"locationLat": localStorage.getItem("locationLat"),
							"locationLon": localStorage.getItem("locationLon")
						}
						that.historyList.unshift(selectCity);
						if (that.historyList.length > 9) {
							that.historyList.splice(9);
						}

						localStorage.setItem("historyList", JSON.stringify(that.historyList))

						that.$router.replace({
							path: '/home',
							query: {

							}
						})
					}


				})
			}
		},
		methods: {
			inputTip() {
				var that = this;
				//初始化地图
				// var map = new AMap.Map('container', {
				// 	resizeEnable: true, //是否监控地图容器尺寸变化
				// 	zoom: 11, //初始地图级别
				// });
				//输入提示
				var auto = new AMap.Autocomplete({
					input: "seachInput"
				});

				AMap.event.addListener(auto, "select", function(e) {
					// console.log(e);
					that.keywords = e.poi.name + " ";
					localStorage.setItem("locationType", 2);
					that.isChangeAddress = true;
				})

			},
			toHome(areaName, LocationCity, locationLat, locationLon) {
				var that = this;
				localStorage.setItem("areaName", areaName);
				localStorage.setItem("LocationCity", LocationCity);
				localStorage.setItem("locationLat", locationLat);
				localStorage.setItem("locationLon", locationLon);
				localStorage.setItem("locationType", 2);
				that.$router.replace({
					path: '/home',
					query: {

					}
				})
			},
			returnHome() {

				this.$router.replace({
					path: '/home',
					query: {

					}
				})
			},
			getLocation() { //获取坐标
				console.log(11111);

				const that = this
				that.loading = true;
				AMap.plugin('AMap.Geolocation', function() {
					var geolocation = new AMap.Geolocation({
						// 是否使用高精度定位，默认：true
						enableHighAccuracy: true,
						// 设置定位超时时间，默认：无穷大
						timeout: 10000,
					})

					geolocation.getCurrentPosition()
					AMap.event.addListener(geolocation, 'complete', onComplete);
					AMap.event.addListener(geolocation, 'error', onError);

					function onComplete(data) {
						// data是具体的定位信息
						console.log('定位成功信息：', data);
						localStorage.setItem("areaName", data.addressComponent.city);
						localStorage.setItem("LocationCity", data.addressComponent.district + data.addressComponent.street);
						localStorage.setItem("locationLat", data.position.lat);
						localStorage.setItem("locationLon", data.position.lng);

						localStorage.setItem("locationType", 2);

						that.returnHome();

					}

					function onError(data) {
						// 定位出错
						console.log('定位失败错误：', data);
						// 调用ip定位
						that.getLngLatLocation();
					}
				})
			},
			getLngLatLocation() {
				var that = this;
				AMap.plugin('AMap.CitySearch', function() {
					var citySearch = new AMap.CitySearch();
					citySearch.getLocalCity(function(status, result) {
						if (status === 'complete' && result.info === 'OK') {
							// 查询成功，result即为当前所在城市信息
							console.log('通过ip获取当前城市：', result);
							
							localStorage.setItem("areaName", result.city);
							
							localStorage.setItem("locationLat", result.rectangle.split(";")[1].split(",")[1]);
							localStorage.setItem("locationLon", result.rectangle.split(";")[1].split(",")[0]);
							localStorage.setItem("locationType", 2);
							that.returnHome();

							//逆向地理编码
							AMap.plugin('AMap.Geocoder', function() {
								var geocoder = new AMap.Geocoder({
									// city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
									city: result.adcode
								})

								var lnglat = result.rectangle.split(';')[0].split(',');
								geocoder.getAddress(lnglat, function(status, data) {
									if (status === 'complete' && data.info === 'OK') {
										// result为对应的地理位置详细信息
										console.log(data);
										localStorage.setItem("LocationCity", data.regeocode.addressComponent.district + (data.regeocode.addressComponent.township || ""));
									}
								})
							})
						}
					})
				})
			}
		},
		beforeRouteLeave(to, from, next) {
			// 导航离开该组件的对应路由时调用
			// 可以访问组件实例 `this`
			if (to.name === 'home') {
				console.log(111111111111)
				this.$router.options.routes[1].meta.keepAlive = false;
			}
			next()
		}

	};
</script>

<style scoped lang="scss">
	.city {
		padding-bottom: 1.6rem;
		text-align: left;

		.cityHead {
			text-align: center;
			height: 0.8rem;
			line-height: 0.8rem;
			position: relative;

			span {
				font-size: 0.3rem;
			}

			i {
				position: absolute;
				width: 0.32rem;
				height: 0.32rem;
				background-image: url(../assets/sqzsIco2.png);
				background-size: auto 100%;
				background-repeat: no-repeat;
				left: 0.32rem;
				top: 50%;
				transform: translateY(-50%);
			}
		}
		
		.nowCity {
			display: inline-block;
			vertical-align: middle;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
			width: 2.1rem;
			padding-left: 0.5rem;
			background-size: auto 100%;
			background-image: url(../assets/fujin.png);
			background-position: 0 50%;
			background-repeat: no-repeat;
			font-size: 0.32rem;
			line-height: 0.44rem;
			color: #fb7102;
		}
		
		.searchCon::before{
			content: "";
			position: absolute;
			width: 0.27rem;
			height: 0.29rem;
			background-image: url(../assets/sqzsIco3.png);
			background-size: cover;
			background-repeat: no-repeat;
			top: 50%;
			left: 0.44rem;
			transform: translateY(-50%);
		}
		.searchCon {
			width: 100%;
			margin: 0.3rem auto;
			padding: 0px 0.18rem;
			position: relative;

			input {
				display: block;
				width: 100%;
				height: 0.63rem;
				border: 1px solid #E0E0E0;
				border-radius: 100px;
				text-indent: 0.64rem;
			}
		}

		.returnMyCity {
			width: 96%;
			margin: 0.5rem auto 0.3rem;

			span {
				padding-left: 0.5rem;
				background-image: url(../assets/dingwei.png);
				background-size: auto 100%;
				background-repeat: no-repeat;
				background-position: 0 50%;
				font-size: 0.32rem;
				line-height: 0.44rem;
			}
		}

		.history {
			width: 96%;
			margin: 0.5rem auto 0.3rem;

			.historyTit {
				font-size: 0.32rem;
				color: #666666;

			}

			.historyList {
				margin-top: 0.3rem;

				li {
					display: inline-block;
					vertical-align: middle;
					padding: 0.1rem 0.22rem;
					background-color: #E0E0E0;
					font-size: 0.28rem;
					border-radius: 0.08rem;
					margin-right: 0.16rem;
					margin-bottom: 0.2rem;
				}
			}

		}

		.nowAddress {
			text-align: left;
			padding: 0px 0.25rem;
			margin-top: 0.3rem;

			.nowAddressTit {
				font-size: 0.24rem;
				color: #333333;
				margin-bottom: 0.3rem;
			}

			.nowAddressList {

				.eachAddress {
					width: 2.03rem;
					height: 0.77rem;
					border: 1px solid #b8b8b8;
					display: inline-block;
					vertical-align: middle;
					margin-right: 0.2rem;
					text-align: center;
					line-height: 0.75rem;
					border-radius: 0.1rem;
					margin-bottom: 0.2rem;
				}
			}

		}

		.cityList {
			text-align: left;
			padding: 0px 0.7rem 0rem 0.25rem;

			.eachWord {
				margin-bottom: 0.2rem;
				margin-top: 0.5rem;

				.eachWordTit {
					font-size: 0.32rem;
					color: #323232;
				}

				.eachWordList {



					div {
						font-size: 0.24rem;
						color: #323232;
						padding: 0.28rem 0px;
						border-bottom: 1px solid #ececec;
						margin-bottom: 0.1rem;
					}
				}

			}
		}
	}
</style>
